import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=1aa9e3c7&"
import script from "./Communication.vue?vue&type=script&lang=js&"
export * from "./Communication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports